<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true" (onHide)="onClose()"
    [style]="{ width: '90vw', maxWidth: '500px' } ">

    <div class=" bg-gray-20 border-gray-300 space-x-4">

        <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-4  sm:px-10">

            <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">Bid Status</h2>

            <p class="text-sm mt-2  font-mulish font-semibold  text-white">Understanding how bids work is key to making
                informed decisions during an auction. Below is a breakdown of each possible bid status—what it means,
                how it
                affects your standing, and what to expect as the auction progresses.</p>
        </div>
        <div class="flex flex-col md:flex-row w-full gap-4 mt-6  text-sm ">
            <div class="rounded-lg bg-white shadow-md text-center mt-4 pb-4">
                <div class="space-y-2 lg:px-2 mt-2 mr-6">

                    <h2 class=" text-lg font-bold  font-mulish text-left">Tie Bid</h2>
                    <p class="font-mulish text-left text-gray-600">
                        Proxy Bidding allows bidders to set a Maximum Bid with the system bidding automatically on their
                        behalf up to that limit. If two bidders enter the same Maximum Bid, the earliest bidder wins the
                        tie.
                    </p>

                    <p class=" text-lg font-bold  font-mulish text-left text-gray-600">Explanation:</p>

                    <p class="font-mulish text-left text-gray-600">
                        Both <span class="font-bold">{{tieExplanation?.winnerNickname || '&lt;username1&gt' }} </span>
                        and
                        <span class="font-bold">{{tieExplanation?.loserNickname || '&lt;username2&gt' }} </span> bid
                        {{tieExplanation?.tieBidAmount || '&lt;tie bid amount&gt;'}} {{currency()}}. Since
                        <span class="font-bold">{{tieExplanation?.winnerNickname || '&lt;username1&gt' }} </span> bid
                        first
                        (on {{tieExplanation?.winnerBidDate | date:'yyyy-MM-dd HH:mm:ss' }})
                        before <span class="font-bold">{{tieExplanation?.loserNickname || '&lt;username2&gt' }} </span>
                        (on
                        {{tieExplanation?.loserBidDate
                        | date:'yyyy-MM-dd HH:mm:ss'
                        }}),
                        <span class="font-bold">{{tieExplanation?.winnerNickname || '&lt;username1&gt' }} </span>
                        remains the leading bidder.
                    </p>


                </div>
            </div>
        </div>
        <div class="px-4">
            <button pButton
                class=" h-[40px] p-button-info rounded-m w-full relative flex items-center justify-center mt-6 "
                [rounded]="true" (click)="onClose()">
                <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>
                <span class="font-semibold text-white text-center w-full text-base">
                    Done
                </span>
            </button>
        </div>
    </div>
</p-dialog>